export default __webpack_public_path__ + "static/media/aktia.7d9ae866.png";